import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import { FormBaseType } from "@green0meter/api-client";

import { Box, Typography } from "@components/base";
import { useMultistepFormStore } from "@components/common/MultistepForm";
import { formatDateUtc } from "@helpers";

interface FormBasicsProps {
  onEdit: () => void;
}

const FormBasics: FC<FormBasicsProps> = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    formSettings: {
      formBasics: { name, validFrom, validTo, formBaseType },
    },
  } = useMultistepFormStore();

  const formName =
    formBaseType === 7
      ? t("csob.form.supplier.co2.title")
      : formBaseType === 9
        ? t("tmobile.form.supplier.co2.title")
        : name;

  return (
    <Box
      p={2}
      sx={{ bgcolor: theme.palette.custom.purple[50], borderRadius: 1 }}
      gap={0.5}
      display={"flex"}
      flexDirection={"column"}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box display="flex" gap={1}>
          <Typography variant="body2" color="text.secondary">
            {t("forms.name")}:
          </Typography>
          <Typography variant="body2" sx={{ flex: 1 }}>
            {formBaseType === FormBaseType.ProcurementSupplier
              ? `${formName} ${t("common.supplier.defaultFormName")}`.trim()
              : formName}
          </Typography>
        </Box>
        {/*{!isLocked && (*/}
        {/*  <StyledIconButton onClick={onEdit} size="small">*/}
        {/*    <Edit />*/}
        {/*  </StyledIconButton>*/}
        {/*)}*/}
      </Box>
      <Box display="flex" gap={1}>
        <Typography variant="body2" color="text.secondary">
          {t("forms.reportingPeriod")}:
        </Typography>
        <Typography variant="body2" sx={{ flex: 1 }}>
          {validFrom ? formatDateUtc(validFrom) : ""}
          {" - "}
          {validTo ? formatDateUtc(validTo) : ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default FormBasics;
